import { formatInTimeZone } from 'date-fns-tz';

export const IST = 'Asia/Kolkata';

export function fmtISTDate(d: Date | string, pattern = 'd MMM'): string {
  return formatInTimeZone(new Date(d), IST, pattern);
}

export function fmtISTRange(a: Date | string, b: Date | string, pattern = 'd MMM'): string {
  const start = fmtISTDate(a, pattern);
  const end = fmtISTDate(b, pattern);
  return start === end ? start : `${start} – ${end}`;
}

export function fmtRelative(d: Date | string): string {
  const date = new Date(d);
  const diffMs = Date.now() - date.getTime();
  const min = Math.round(diffMs / 60_000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min}m ago`;
  const h = Math.round(min / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.round(h / 24);
  if (days < 7) return `${days}d ago`;
  return fmtISTDate(date);
}
